import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

class AircraftLogbookNoDiscrepanciesTab extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loaded: 0,
      aircraft_logbook_id: this.props.aircraft_logbook_id,
      rows: [],
    };
    this.load = this.load.bind(this);
    this.toggle = this.toggle.bind(this);
  }

  componentWillReceiveProps(newProps) {
    if (this.state.loaded === 0) {
      this.setState({ loaded: 1, aircraft_logbook_id: newProps.aircraft_logbook_id }, this.load);
    }
  }

  load() {
    const header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then((value) => {
      const url = config.get('api') + '/aeronave/diario/sem-discrepancias/' + this.state.aircraft_logbook_id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value })
        .then((response) => response.json())
        .catch((error) => { console.error(error); })
        .then((responseJson) => {
          this.refs.request_api.validate(responseJson);
          if (responseJson.status === 'success') {
            this.setState({ rows: responseJson.data || [] });
          }
        });
    });
  }

  toggle(row) {
    this.props.handleAlert('', '', 'open');
    const confirmed = row.confirmed === 1;
    const header = this.refs.request_api.header('application/json');
    const url = confirmed ? (config.get('api') + '/aeronave/diario/sem-discrepancias') : (config.get('api') + '/aeronave/diario/sem-discrepancias');
    const method = confirmed ? 'DELETE' : 'POST';
    const body = confirmed
      ? JSON.stringify({ id: row.id })
      : JSON.stringify({
          aircraft_logbook_id: row.aircraft_logbook_id,
          flight_report_id: row.flight_report_id,
          flight_report_leg_id: row.flight_report_leg_id,
        });

    Promise.resolve(header).then((value) => {
      fetch(url, { method: method, mode: 'cors', headers: value, body })
        .then((response) => response.json())
        .catch((error) => { console.error(error); })
        .then((responseJson) => {
          this.refs.request_api.validate(responseJson, 'alert');
          this.props.handleAlert(responseJson.message, responseJson.status, 'open');
          if (responseJson.status === 'success') {
            this.load();
            if (typeof this.props.updateData === 'function') {
              this.props.updateData(responseJson);
            }
          }
        });
    });
  }

  render() {
    const self = this;
    return (
      <div>
        <RequestApi ref='request_api' />
        <h3 className="page-title pull-left">Flight Reports Without Discrepancies</h3>
        <div className="clearfix"></div>
        <hr/>
        <div className="table-responsive">
          <table className="table table-bordered table-hover table-striped">
            <thead>
              <tr>
                <th>Flight Report ID</th>
                <th>Flight Leg</th>
                <th>No Discrepancies</th>
              </tr>
            </thead>
            <tbody>
              {self.state.rows.map((r) => (
                <tr key={r.flight_report_leg_id} className='text-center'>
                  <td>{r.flight_report_id}</td>
                  <td>{r.leg_label}</td>
                  <td>
                    <button onClick={() => this.toggle(r)} className={'btn btn-sm btn-success'} disabled={r.confirmed ? true : false}>
                      <span className="fa fa-check" /> {r.confirmed ? 'Confirmed' : 'Confirm'}
                    </button>
                  </td>
                </tr>
              ))}
              {self.state.rows.length === 0 && (
                <tr><td colSpan={3} className='text-center'>No items</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

export default AircraftLogbookNoDiscrepanciesTab;



// WEBPACK FOOTER //
// ./src/Components/AircraftLogbooks/Elements/AircraftLogbookNoDiscrepanciesTab.js